import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export const Wedding = () => {
  const [timerDays, setTimerDays] = useState("00");
  const [timerHours, setTimerHours] = useState("00");
  const [timerMinutes, setTimerMinutes] = useState("00");
  const [timerSeconds, setTimerSeconds] = useState("00");
  const navigate = useNavigate();

  let interval = useRef();

  const startTimer = () => {
    const CountdownDate = new Date("December 23 2023 00:00:00").getTime();

    interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = CountdownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        //stop our timer
        clearInterval(interval.current);
      } else {
        //update timer
        setTimerDays(days);
        setTimerHours(hours);
        setTimerMinutes(minutes);
        setTimerSeconds(seconds);
      }
    }, 1000);
  };
  //componentDidmount
  useEffect(() => {
    startTimer();
    return () => {
      clearInterval(interval.current);
    };
    //react-hooks/exhaustive-deps
  });

  var x = document.getElementById("myAudio");

  function playAudio() {
    x.play();
  }

  return (
    <>
      <section className="starting">
        <section className="start">
          <div>
            <h1>Nuestra Boda</h1>
            <p>Tu eres parte de este sueño</p>
          </div>
          <div>
            <audio id="myAudio">
              <source src="./img/music.mp3" type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
            <div>
              <button
                className="btn btn-light"
                onClick={() => playAudio()}
                style={{ fontSize: "24px" }}
                type="button"
              >
                <i className="bi bi-music-note-beamed">Play</i>
              </button>
            </div>
          </div>
        </section>
      </section>

      <section className="timer-container">
        <section className="timer">
          <div>
            <span></span>
            <h1>Solo faltan...</h1>
          </div>
          <div>
            <section>
              <p>{timerDays}</p>
              <p>
                <small>Dias</small>
              </p>
            </section>
            <span>:</span>
            <section>
              <p>{timerHours}</p>
              <p>
                <small>Horas</small>
              </p>
            </section>
            <span>:</span>
            <section>
              <p>{timerMinutes}</p>
              <p>
                <small>Minutes</small>
              </p>
            </section>
            <span>:</span>
            <section>
              <p>{timerSeconds}</p>
              <p>
                <small>Segundos</small>
              </p>
            </section>
          </div>
        </section>
      </section>
      <h4
        style={{
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "0.8em",
        }}
      >
        Te esperamos el 23 de Diciembre
      </h4>
      {/* -- Carousel -- */}
      <div id="demo" class="carousel slide" data-bs-ride="carousel">
        {/* <!-- Indicators/dots --> */}
        <div class="carousel-indicators">
          <button
            type="button"
            data-bs-target="#demo"
            data-bs-slide-to="0"
            class="active"
          ></button>
          <button
            type="button"
            data-bs-target="#demo"
            data-bs-slide-to="1"
          ></button>
          <button
            type="button"
            data-bs-target="#demo"
            data-bs-slide-to="2"
          ></button>
          <button
            type="button"
            data-bs-target="#demo"
            data-bs-slide-to="3"
          ></button>
          <button
            type="button"
            data-bs-target="#demo"
            data-bs-slide-to="4"
          ></button>
          <button
            type="button"
            data-bs-target="#demo"
            data-bs-slide-to="5"
          ></button>
           <button
            type="button"
            data-bs-target="#demo"
            data-bs-slide-to="6"
          ></button>
           <button
            type="button"
            data-bs-target="#demo"
            data-bs-slide-to="7"
          ></button>
        </div>

        {/* <!-- The slideshow/carousel --> */}
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="./img/paloma.jpg" alt="Los Angeles" class="img-fluid" />
           
          </div>
          <div class="carousel-item">
            <img src="./img/paloma2.jpg" alt="Chicago" class="img-fluid" />
            
          </div>
          <div class="carousel-item">
            <img src="./img/paloma3.jpg" alt="New York" class="img-fluid" />
            
          </div>
          <div class="carousel-item">
            <img src="./img/paloma4.jpg" alt="New York" class="img-fluid" />
            
          </div>
          <div class="carousel-item">
            <img src="./img/paloma5.jpg" alt="New York" class="img-fluid" />
           
          </div>
          <div class="carousel-item">
            <img src="./img/cachito4.jpeg" alt="New York" class="img-fluid" />
           
          </div>
          <div class="carousel-item">
            <img src="./img/cachito6.jpeg" alt="New York" class="img-fluid" />
           
          </div>
          <div class="carousel-item">
            <img src="./img/cachito7.jpeg" alt="New York" class="img-fluid" />
           
          </div>
        </div>

        {/* <!-- Left and right controls/icons --> */}
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#demo"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon"></span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#demo"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon"></span>
        </button>
      </div>

      <section className="padrinos">
        <section className="padrinos-c">
          <div>
            <h5><b>CON LA BENDICION DE DIOS Y NUESTROS PADRES</b></h5>
            <p>Cesar Miramontes & Maria del Carmen Lopéz</p>
            <p>Francisco Ceceña & Bertha González</p>
          </div>
          <br />
          <h5><b>NUESTROS PADRINOS</b></h5>
          <h6>Velacion</h6>
          <p>Miguel Ceceña & Maria de Jesus González</p>
          <h6>Anillos</h6>
          <p>Antonio Flores & Maria Cristina Ceceña</p>
          <h6>Arras</h6>
          <p>Miguel Ceceña González & Dora Isabel Ortega</p>
          <h6>Lazo</h6>
          <p>Juan Carlos Miramontes & Martha Ulloa</p>
          <h6>Biblia y Rosario</h6>
          <p>Raul González Beltrán & Selene Rivas Aispuro</p>
          <h6>Ramo Natural</h6>
          <p>Tania Elizabeth González Espinoza</p>
          <h6>Brindis</h6>
          <p>Efrén López Villegas</p>
        </section>
      </section>

      <section className="iglesia">
        <section className="iglesia-f">
          <div class="card" style={{ width: "18rem" }}>
            <img src="./img/iglesia.webp" class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">BODA RELIGIOSA</h5>
              <p class="card-text">
                Iglesia de nuestra señora de Fatima - 7:00 pm
              </p>
              <a
                href="https://maps.app.goo.gl/G5UjssMBo2biVXGw5"
                class="btn btn-primary"
                style={{
                  backgroundColor: "#3271a8",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "3.5em",
                }}
              >
                Ver Ubicacion
              </a>
            </div>
          </div>
          <br />
          <div class="card" style={{ width: "18rem" }}>
            <img src="./img/casino.jpg" class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">RECEPCION</h5>
              <p class="card-text">La Huerta Jardín & Eventos - 8:30 pm</p>
              <a
                href="https://maps.app.goo.gl/2uYqaMEEjeRR5bKd6"
                class="btn btn-primary"
                style={{
                  backgroundColor: "#3271a8",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "3.5em",
                }}
              >
                Ver Ubicacion
              </a>
            </div>
          </div>
        </section>
      </section>

      <section className="mesaRegalos">
        <section className="mesaRegalos-c">
          <div>
            <h2>MESA DE REGALOS</h2>
            <br />
            <p>Agradecemos mucho todo su cariño </p>{" "}
            <p>y apoyo para iniciar esta nueva etapa</p>
            
            <img src="./img/liverpool1.png" style={{ width: "5em" }} />
            <br></br>
            <br></br>
            <a
              href="https://mesaderegalos.liverpool.com.mx/milistaderegalos/51318534"
              class="btn btn-secondary"
            >
              Haz Click Aqui
            </a>
            <br></br>
            <br></br>
            <img src="./img/amazon.png" style={{ width: "5em" }} />
            <br></br>
            <br></br>
            <a
              href="https://www.amazon.com.mx/wedding/registry/1KZNEWLR3M5T"
              class="btn btn-secondary"
            >
              Haz Click Aqui
            </a>
            
          </div>
        </section>
      </section>

      <section className="confirmation">
        <section className="confirm">
          <div>
            <h3
              style={{
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "1em",
              }}
            >
              CONFIRMA TU ASISTENCIA
            </h3>
            <p>!Nos hará muy felices contar con tu presencia!</p>

            {/* <a
              href={`https://api.whatsapp.com/send?phone=3112857138&text=Hola,%20¿qué%20tal%20Quisera%20confirmar%20mi%20Asistencia.%20Adultos:%20${adultos},%20Niños:%20${ninos},%20Personas:%20${nombres}`}
              type="button"
              class="btn btn-dark"
              style={{
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "6em",
                marginTop:"2em"
              }}
            >
              CONFIRMA AQUI
            </a> */}
            <button
              type="button"
              class="btn btn-dark"
              style={{
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "6em",
                marginTop: "2em",
              }}
              onClick={() => {
                navigate("/confirm");
              }}
            >
              CONFIRMA AQUI
            </button>
          </div>
        </section>
      </section>
      {/* -- Carousel -- */}
      <div id="demo2" class="carousel slide" data-bs-ride="carousel">
        {/* <!-- Indicators/dots --> */}
        <div class="carousel-indicators">
          <button
            type="button"
            data-bs-target="#demo2"
            data-bs-slide-to="0"
            class="active"
          ></button>
          <button
            type="button"
            data-bs-target="#demo2"
            data-bs-slide-to="1"
          ></button>
          <button
            type="button"
            data-bs-target="#demo2"
            data-bs-slide-to="2"
          ></button>
           <button
            type="button"
            data-bs-target="#demo2"
            data-bs-slide-to="3"
          ></button>
        </div>

        {/* <!-- The slideshow/carousel --> */}
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              src="./img/cac2.jpg"
              alt="Los Angeles"
              class="img-fluid"
            />
            <div class="carousel-caption">
              
              <p>!Cumpliendo metas juntos!</p>
            </div>
          </div>
          <div class="carousel-item">
            <img src="./img/cac3.jpg" alt="Chicago" class="img-fluid" />
            <div class="carousel-caption">
              
              
              <p>!Motivando al otro, día con día para lograr lo propuesto!</p>
            </div>
          </div>
          <div class="carousel-item">
            <img src="./img/cac1.jpg" alt="New York" class="img-fluid" />
            <div class="carousel-caption">
              
            <p>!El amor es una aventura que vale la pena explorar juntos!</p>
            </div>
          </div>
          <div class="carousel-item">
            <img src="./img/cac4.jpg" alt="New York" class="img-fluid" />
            <div class="carousel-caption">
             
              <p>!El primer beso y el inicio de un gran amor!</p>
            </div>
          </div>
        </div>

        {/* <!-- Left and right controls/icons --> */}
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#demo2"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon"></span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#demo2"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon"></span>
        </button>
      </div>
    </>
  );
};
